import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CommentIcon from '@wix/da-ds/pkg/Icons/Comment';
import { useReplyButtonBase } from './useReplyButtonBase';
import s from './ReplyButton.scss';
const ReplyButton = ({ className, disabled: disabledOverride })=>{
    const { onClick, disabled } = useReplyButtonBase({
        disabledOverride
    });
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: className,
        onClick: onClick,
        disabled: disabled
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['reply-with-icon']
    }, /*#__PURE__*/ React.createElement(CommentIcon, {
        className: s['reply-icon'],
        size: IconSize.SMALLER
    }), t('comment.action.reply')));
};
ReplyButton.displayName = 'ReplyButton';
export default ReplyButton;
